'use client';

import React, { useEffect } from 'react';
import useAnalytics from '@/libs/analytics/useAnalytics';

export const Analytics = () => {
  useAnalytics(process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS || ''); // Replace with your actual Google Analytics measurement ID
  return <></>;
};